import './App.css';
import 'react-datepicker/dist/react-datepicker.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Auth from './service/auth';
import API from './service/api';

import Protected from 'component/Protected';

import PopMessage           from 'component/pop-msg/PopMessage';

import MenuNavigator        from 'component/MenuNavigator';
import HomeView             from 'view/sys/HomeView';
import LoginView            from 'view/sys/LoginView';
import ChangePasswordView   from 'view/info/ChangePasswordView';

import ClientListView       from 'view/info/ClientListView';
import StaffView            from 'view/info/StaffView';
import ServiceLocationView  from 'view/info/ServiceLocationView';
import ServicePlanView      from 'view/info/ServicePlanView';
import UnitServiceView      from 'view/info/UnitServiceView';

import ServiceView          from 'view/op/ServiceView';
import OverdueView          from 'view/op/OverdueView';
import PayReceiptView       from 'view/op/PayReceiptView';
import WorkerScheduleView   from 'view/op/schedule/WorkerScheduleView';
import LocationScheduleView from 'view/op/schedule/LocationScheduleView';
import LeaveView            from 'view/op/LeaveView';
import OrderView            from 'view/op/OrderView';
import MessageView          from 'view/op/messages/MessageView';

import ServiceLogView       from 'view/records/ServiceLogView';
import SuspensionLogView    from 'view/records/SuspensionLogView';
import PaymentView          from 'view/records/PaymentView';
import EInvoicingAuditView  from 'view/records/EInvoicingAuditView';

import ProfitReportView     from 'view/report/ProfitReportView';
import LocationReportView   from 'view/report/LocationReportView';
import StaffSalaryView      from 'view/report/StaffSalaryView';
import LHSReportView        from 'view/report/LHSReportView';

import SwitchWorkerView     from 'view/admin/SwitchWorkerView';
import MergeCustView        from 'view/admin/MergeCustView';
import SplitCustView        from 'view/admin/SplitCustView';

const App = () =>
{
  const [cnnMsg, setConnectionMessage] = useState('正在連接至伺服器...');
  const [appInfo, setAppInfo] = useState('');

  const getLoginElement = () =>
  {
    if ( Auth.User )
    {
      return (
        <div className="salute fmidcen">
          <span>{ Auth.User.Name }</span>
          <ul>
            <li id="btn-chpswd"><a href="/change-password">更改密碼</a></li>
            <li id="btn-logout" onClick={ Auth.logout }>登出</li>
          </ul>
        </div>
      );
    }
    return <div className="fmidcen"><a id="btn-login" href="/login">登入</a></div>;
  }

  const connectServer = () =>
  {
    setConnectionMessage('正重新連接至伺服器...');
    API.getAppVersion().then(resp => {
      if (!resp.version) {
        // reconnect after 15 seconds
        setConnectionMessage('無法連接至伺服器，15秒後重試。');
        setTimeout(connectServer, 15000);
      } else {
        setConnectionMessage(false);
        setAppInfo(resp);
      }
    });
  }

  useEffect(connectServer, []);

  if (cnnMsg)
  {
    return (<>
      <header className={[Auth.User?.Role, appInfo.env].join(' ')}>
        <a className="fmidcen" href="/" id="btn-home">
          <div className="title">天記</div>
          <div className="sub-title">營運管理系統</div>
        </a>
      </header>
      <main>
        <p className="message blue">{ cnnMsg }</p>
      </main>
    </>);
  }


  return (
    <>
      <Router>
        <header className={[Auth.User?.Role, appInfo.env].join(' ')}>
          <a className="fmidcen" href="/" id="btn-home">
            <div className="title">天記</div>
            <div className="sub-title">營運管理系統</div>
          </a>
          <MenuNavigator />
          { getLoginElement() }
        </header>
        <main className={Auth.User?.Role.toLowerCase()}>
          <Routes>
            {/* info */}
            <Route path="/info/staff"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR']}>
                  <StaffView />
                </Protected>
              }/>
            <Route path="/info/owners"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <ClientListView />
                </Protected>
              }/>
                        <Route path="/info/service-locations"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <ServiceLocationView />
                </Protected>
              }/>
            <Route path="/info/service-plans"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <ServicePlanView />
                </Protected>
              }/>
            <Route path="/info/unit-services"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <UnitServiceView />
                </Protected>
              }/>
            {/* operation */}
            <Route path="/op/services/:license?/:owner_id?"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <ServiceView />
                </Protected>
              }/>
            <Route path="/op/bills/overdue"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY']}>
                  <OverdueView />
                </Protected>
              }/>
            <Route path="/op/bills/payment"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR']}>
                  <PayReceiptView />
                </Protected>
              }/>
            <Route path="/op/staff/schedule"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_NIGHT']}>
                  <WorkerScheduleView />
                </Protected>
              }/>
            <Route path="/op/location/schedule"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_NIGHT']}>
                  <LocationScheduleView />
                </Protected>
              }/>
            <Route path="/op/staff-leave"
              element={
                <Protected>
                  <LeaveView />
                </Protected>
              }/>
            <Route path="/op/orders"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <OrderView />
                </Protected>
              }/>
            <Route path="/op/messages"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <MessageView />
                </Protected>
              }/>
            {/* record log */}
            <Route path="/rec/monthly-services"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <ServiceLogView />
                </Protected>
              }/>
            <Route path="/rec/suspended-services"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <SuspensionLogView />
                </Protected>
              }/>
            <Route path="/rec/cheque-records"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <PaymentView />
                </Protected>
              }/>
            <Route path="/rec/einvoicing-audits"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_DAY','VIEWER_NIGHT']}>
                  <EInvoicingAuditView />
                </Protected>
              }/>
            {/* reports */}
            <Route path="/reports/profit"
              element={
                <Protected allow={['VIEWER_SU']}>
                  <ProfitReportView />
                </Protected>
              }/>
            <Route path="/reports/優悠家居"
              element={
                <Protected allow={['VIEWER_SU']} >
                  <LHSReportView />
                </Protected>
              }/>
            <Route path="/report/service-by-location"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR','VIEWER_NIGHT']}>
                  <LocationReportView />
                </Protected>
              }/>
            <Route path="/report/staff-salary"
              element={
                <Protected allow={['VIEWER_SU','OPERATOR']}>
                  <StaffSalaryView />
                </Protected>
              }/>
            { /*  */}
            <Route path="/admin/switch-worker"
              element={
                <Protected>
                  <SwitchWorkerView />
                </Protected>
              }/>
            <Route path="/admin/merge-customer"
              element={
                <Protected>
                  <MergeCustView />
                </Protected>
              }/>
            <Route path="/admin/split-customer"
              element={
                <Protected>
                  <SplitCustView />
                </Protected>
              }/>
            {/* default */}
            <Route path="/change-password"
              element={
                <Protected allow={true}>
                  <ChangePasswordView />
                </Protected>
              }/>
            <Route path="/login"
              element={<LoginView />} />
            <Route path="/"
              element={<HomeView />} />
            <Route path="*"
              element={() => <Navigate to="/" />} />
          </Routes>
        </main>
        <footer>
          <span id="app-version">{ appInfo.version }-{ appInfo.env }</span>
        </footer>
      </Router>
      { PopMessage.Instance }
    </>
  );

}

export default App;
